export enum SessionStorage {
    userId = 'userId'
}